import React, { useState, useEffect } from "react";
//import { confirm } from "react-confirm-box";
import axios from 'axios';
import {Link, NavLink } from "react-router-dom";
import { useLocation } from "react-router";
import $ from 'jquery';

import { useNavigate } from 'react-router-dom'
//var dateFormat = require('dateformat');

	

const Renderpdfdoc = () => {

const scansurl=sessionStorage.getItem("SCANSURL");	
const resturl=sessionStorage.getItem("RESTURL");
let customspremurl=sessionStorage.getItem("CUSTOMSPREMURL");
//var boolFetchingSads=false;

const navigate = useNavigate();

window.addEventListener("keypress", function (event) {
 // detect event keys
 if (event.keyCode == 13) {
   //callsadfinder();
   
 }
});


const [modal, setModal] = useState({open:false});
const [cbready, setCbready] = useState({checked:false});

const navWpform = React.useRef();
const [progress, setProgress] = useState({
perct:null
});


const [tblpdfdoc, setTblpdfdoc] = useState([]);

const [arraypdfdoc, setArraypdfdoc] = useState([]);



const [pdfdoc, setPdfdoc] = useState({USER_PDF_DOC_ID: ""});

const [axiofl, setAxiofl] = useState({selectedFiles: null});
const [dowait, setDowait] = useState({show:false});





const location = useLocation();


useEffect(() => {

if (sessionStorage.getItem("USERNAME")==null || sessionStorage.getItem("USERNAME")=="null" || sessionStorage.getItem("USERNAME")==undefined || sessionStorage.getItem("USERNAME")==""){
	navigate("/");
	return;
	}//end if

document.title =   "Pdf Docs";

	
 },[]);

useEffect(() => {

//if (tblpdfdoc.length>0 && pdfdoc.USER_PDF_DOC_ID>0)
	//mergepdfdocs();
		
 },[JSON.stringify(tblpdfdoc)]);



useEffect(() => {
	
	const EMBED_PATH=pdfdoc.EMBED_PATH??"";
	console.log("EMBED_PATH: "+EMBED_PATH);
	
		if (EMBED_PATH=="")
			document.getElementById("embed1").src="";
		else{
			//file:///D:/aps/000125/Google%20Chrome%20Setting%20for%20Pdf.pdf
			document.getElementById("embed1").src=resturl+pdfdoc.EMBED_PATH;
			}
			
		
 },[pdfdoc.EMBED_PATH]);





useEffect(() => {
	 
	 //console.log("tblpdfdoc: "+JSON.stringify(tblpdfdoc));

				
	
 },[JSON.stringify(tblpdfdoc)]);

 

 
useEffect(() => {
	 
	 if (arraypdfdoc.length>0)
		writetblpdfdoc();
	else{
		setTblpdfdoc([]);
		}
		
	
 },[JSON.stringify(arraypdfdoc)]);
 
 
 
useEffect(() => {
	 console.log("cbready.checked: "+cbready.checked);
	
 },[JSON.stringify(cbready.checked)]);
 
 




function toggleModalsm() {
if (!document.querySelector(".modalsm"))
	return false;


	
const modalsm = document.querySelector(".modalsm");
	
console.log('modalsm is null: '+(modalsm==null));
modalsm.classList.toggle("show-modalsm");
const isopen=modalsm.classList.contains("show-modalsm");
setModal((prev)=>{return {...prev, open:isopen};})

if (document.querySelector(".close-button")){
	const closeButton = document.querySelector(".close-button");
	if(!closeButton.classList.contains('attached-listener')){
		closeButton.classList.add('attached-listener');
		closeButton.addEventListener("click", toggleModalsm);
		window.addEventListener("click", windowOnClick);
		}//end if
	}//end if
return false;
}//end func



function windowOnClick(event) {
const modalsm = document.querySelector(".modalsm");
	
console.log('event.target === modalsm: '+(event.target === modalsm));
	
    if (event.target === modalsm) {
    	toggleModalsm();
    }//end if
	
	
/*
if (show==false && event.target===document.getElementById("checkBoxes")) {
	document.getElementById("checkBoxes").style.display = "none";
	show = true;
	}	//end if

*/	
    
}//end func



async function mergepdfdocs(e){

//if (!e.target.classList.contains("hidden"))
	//e.target.classList.add("hidden");
setCbready((prev)=>{
	return {...prev, checked: false}
	});

let params = {
	USERNAME: sessionStorage.getItem("USERNAME")??""
	, USER_PDF_DOC_ID: pdfdoc.USER_PDF_DOC_ID
	};

console.log("mergepdfdocs: "+JSON.stringify(params));

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		

  await fetch(resturl+'rarwpform/mergeuserpdfdoc',requestOptions)
      .then(res => res.json())
      .then(res => 	aftermergeuserpdfdoc(res) )
      .catch(err => console.log(err));

}//end func

function aftermergeuserpdfdoc(res){
	const FINAL_FILE=res.length?(res[0].FINAL_FILE??""):"";
	if (FINAL_FILE==""){
		//showsnackbar("An error occured");
		}//end if
	else{
		//document.getElementById("presult").innerHTML="please verify the total number of pages is correct, then download the file";
		document.getElementById("embed1").src=resturl+FINAL_FILE;
		}//end if
		
		
}//end func

function startover(e){
	if (e)
		e.preventDefault();
	
	const userconfirm=window.confirm("clear the form?");
	if (!userconfirm)
		return;
	
		document.getElementById("embed1").src="";
		setArraypdfdoc([]);
		setTblpdfdoc([]);
		setPdfdoc({USER_PDF_DOC_ID: ""});
		setAxiofl({selectedFiles: null});
		setCbready({checked:false});	
		window.scrollTo({ top: 0, behavior: "smooth" });
}//end func

async function gettblpdfdoc(){

let params = {
	USERNAME: sessionStorage.getItem("USERNAME")??""
	, USER_PDF_DOC_ID: pdfdoc.USER_PDF_DOC_ID
	};

console.log("gettblpdfdoc: "+JSON.stringify(params));

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		
setTblpdfdoc([]);
  await fetch(resturl+'rarwpform/gettbluserpdfdoc',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergettblpdfdoc(res) )
      .catch(err => console.log(err));

}//end func

function aftergettblpdfdoc(res){
	
	
if (!res.length){
	console.log("abort aftergettblpdfdoc for !res.length)")
	return;
	}
	
console.log('aftergettblpdfdoc, res.length: '+res.length);

let arrtemp=[];

res.map((col, index) => {
	let datas={};
	for(var attributename in col){
			const data=col[attributename];
			//console.log('attributename, data: '+attributename+", "+data);
			datas[attributename] = (data==null)?'':data;
			//MODIFY_DATE
		}//end for	

	arrtemp.push(datas);

});
//console.log('arrtemp: '+JSON.stringify(arrtemp));
setArraypdfdoc(arrtemp);

}//end func


function writetblpdfdoc(){
	//console.log('writetblpdfdoc: '+JSON.stringify(arraypdfdoc));
let mprhtmrows=[], pdfdochtmrows=[];
let TOTAL_PAGE_COUNT=0;
	
	for (var index=0; index<arraypdfdoc.length; index++){
		const col=arraypdfdoc[index];
		const USER_PDF_DOC_ID=col['USER_PDF_DOC_ID'];
		const trkey='tr_'+index;
			
/*
			const radioId='rdpdfdoc_'+index;
			<input type="radio" name="rdpdfdoc"  value={col['USER_PDF_DOC_ID']} id={radioId} onClick={(e)=>{openpdfdoc(e, col);}} /><label htmlFor={radioId} className="hand" >{col['FILE_NAME'].substring(0,24)}</label>

*/			//console.log('radioId: '+radioId);
			const htmrow=<tr key={trkey} >
			<td align='right' >{1+index}</td>
			<td align='left' >{col['FILE_NAME'].substring(0,60)}</td>
			<td align='right' >{col['SEQ_NO']}</td>
			<td align='right' >{col['PAGE_COUNT']}</td>
			<td align='right' >{col['FILE_SIZE']}</td>
			</tr>;
			pdfdochtmrows.push(htmrow);
			TOTAL_PAGE_COUNT+=col['PAGE_COUNT'];

		}//end for

pdfdochtmrows.push(<tr key={"xtr_01"} style={{fontWeight:"bold", color:"brown"}} ><td colSpan="3" align='right'  >Total # of Pages:</td><td align='right' >{TOTAL_PAGE_COUNT}</td></tr>);
setTblpdfdoc(pdfdochtmrows);
	
}//end func


function handleFileChange(event) {

setAxiofl({ selectedFiles: null });

if (event.target.files.length>1 && pdfdoc.USER_PDF_DOC_ID==0){
	document.getElementById("fileinput").value='';
	window.alert("upload only one file please");
	return;
	}
else if (event.target.files.length<=0){
	document.getElementById("fileinput").value='';
	window.alert("aborting: no file was receifed for upload");
	return;
	}
	
const fileName=event.target.files[0].name;
var fileExtension = "";
if (fileName.lastIndexOf(".") > 0) 
	fileExtension = fileName.substring(fileName.lastIndexOf(".") + 1, fileName.length);
//,.jpg,.jpeg
const lsExtension="pdf";
if (!(", "+lsExtension).includes(", "+fileExtension)){
	document.getElementById("fileinput").value='';
	window.alert("error: allowed file extensions: "+lsExtension);
	return;
	}//end if	

console.log("event.target.files.length: "+event.target.files.length);

if (event.target.files.length>=1){

	// Update the state
	setAxiofl({ selectedFiles: event.target.files });

/*
	setPdfdoc((prev)=>{
		return {...prev, USER_PDF_DOC_ID: ""}
		});
*/

	}//end if

}//end function


async function appendpdfdocOld(e){
	
}//end function

function openpdfdoc(e, col){
	
	//e.preventDefault();
	//e.target.checked=true;
	console.log("openpdfdoc: arraypdfdoc.length"+arraypdfdoc.length);

	setPdfdoc(col);

	
}//end func




	


function showsnackbar(innerHTML) {
  var x = document.getElementById("snackbar");
  x.innerHTML=innerHTML;
  x.className = "show";
  setTimeout(function(){ x.className = x.className.replace("show", ""); }, 2500);
}//end func

async function insertuserpdfdoc (e) {

if (arraypdfdoc.length>=15){
	window.alert("No more than 15 pdf files allowed!");
	return;
	}//end if

if (axiofl.selectedFiles.length>10){
	window.alert("No more than 10 pdf files allowed for upload!");
	return;
	}//end if

if (axiofl.selectedFiles.length<1){
	window.alert("No pdf files were received for upload!");
	return;
	}//end if

const USERNAME=(pdfdoc.USER_PDF_DOC_ID>0)?pdfdoc.USER_PDF_DOC_ID:sessionStorage.getItem("USERNAME")??"";

if (document.getElementById("presult"))
	document.getElementById("presult").innerHTML="";
document.getElementById("embed1").src="";

let temp=[];
for (var i=0; i<axiofl.selectedFiles.length; i++){
	temp.push({
		name: axiofl.selectedFiles[i].name??""
		, size: axiofl.selectedFiles[i].size??0
		});
	}//end for
		
const params={
	USERNAME: USERNAME
	, USER_PDF_DOC_ID: pdfdoc.USER_PDF_DOC_ID
	, selectedFiles: temp
};

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		

  await fetch(resturl+'rarwpform/insertuserpdfdoc',requestOptions)
      .then(res => res.json())
      .then(res => 	afterinsertuserpdfdoc(res) )
      .catch(err => console.log(err));

}//end func


async function afterinsertuserpdfdoc(res){
	const NEW_PDF_FILE_NAME = res.length?(res[0].NEW_PDF_FILE_NAME??0):0;
	if (NEW_PDF_FILE_NAME==0)
		window.alert("Aborting:  Did not get a new NEW_PDF_FILE_NAME");
	else{
		setPdfdoc((prev)=>{
			return {...prev, USER_PDF_DOC_ID: res[0].USER_PDF_DOC_ID}
			});
		uploaduserpdfdoc (res);
		}//end else
		
}//end func


async function uploaduserpdfdoc (res) {

const res1 = res[0];
 
 const FormData = require('form-data'); // npm install --save form-data

const form = new FormData();
let arrPdffiles=[], arrFilenames=[];
let filenames="", seqnos="";
for (var i=0; i<axiofl.selectedFiles.length; i++){
	if (i>0){
		filenames+=",";
		seqnos+=",";
		}
		
	
	filenames+=res[i].NEW_PDF_FILE_NAME??"";
	seqnos+=res[i].SEQ_NO??0;
/*
	arrFilenames.push({
		FILE_NAME: res[i].NEW_PDF_FILE_NAME??""
		, SEQ_NO: res[i].SEQ_NO??0
		});

*/
	}//end for


form.append('USERNAME', sessionStorage.getItem("USERNAME"));
form.append('REF_NUM', res1.REF_NUM??"");
form.append('USER_PDF_DOC_ID', res1.USER_PDF_DOC_ID??"");
//form.append('SEQ_NO', res1.SEQ_NO??"");
form.append('filenames', filenames);
form.append('seqnos', seqnos);
for (var i=0; i<axiofl.selectedFiles.length; i++){
	const newFile=new File([axiofl.selectedFiles[i]], res[i].NEW_PDF_FILE_NAME??"");
	form.append('files', newFile);
	}//end for
	


setDowait({show:true});
//importingwptapp=true;
const request_config = {
    onUploadProgress: data => {
      //Set the progress value to show the progress bard
      setProgress({perct:Math.round((100 * data.loaded) / data.total)});
    },
};
await axios.post(scansurl+'rarscans/uploaduserpdfdoc', form, request_config)
//.then(res => res.data.json())
.then(res => 	afteruploaduserpdfdoc(res1.USER_PDF_DOC_ID, res.data) )
.catch(error => { 
		setDowait({show:false});
         showsnackbar(error+"<br/>please try logout and login again");
     });//end catch
	 
}//end function


function afteruploaduserpdfdoc(USER_PDF_DOC_ID, res){
	console.log('afteruploaduserpdfdoc USER_PDF_DOC_ID: '+USER_PDF_DOC_ID);
	console.log('res.length: '+res.length);
	setDowait({show:false});
	setAxiofl({ selectedFiles: null });


	document.getElementById('fileinput').value='';
	showsnackbar("done!");
	
	aftergettblpdfdoc(res);
	//mergepdfdocs();
	//setArraypdfdoc(res);
	//gettblpdfdoc();
}//end function

function clickCbready(e){
	setCbready({checked:e.target.checked});
	
}//end func

function handleChange(e){
	const {name, value} = e.target;
	
	setPdfdoc((prev)=>{
		return {...prev, [name]:value}
		});
}//end func

function pdfLoaded(e){
	//window.alert("Done");
	
}//end func

  return (
    <>
	
	<p align="center" className="Acme" style={{marginBottom:"6px", marginTop:"9px", color:"brown",fontSize:"24px"}} >Merge Pdf Documents</p>	
	
	<p align="center" >before you start, please consider that your final merged file should be presentable to immigration,
	<br/> and your pdf files should be close to letter size or legal size</p>
	

		{pdfdoc.USER_PDF_DOC_ID==0 && 
		<table align='center'  style={{width:"55%"}} >
		<tbody>
		<tr>
			<td align="right">Start by uploading a pdf file:</td>
			<td align="left"><input type="file" id="fileinput" accept=".pdf,*.jpg,*.png" onChange={(e)=>{handleFileChange(e);}}   />
				{dowait.show==true && <><img src='img/Loading_2.gif' border='0' height='36' /> . . . please wait</>}
				{
				dowait.show==false && axiofl.selectedFiles!=null && 
				<button onClick={(e)=>{insertuserpdfdoc(e);}} className='button' id='btnuploadpdf' >upload pdf file</button>
				}
			</td>
		</tr>
		</tbody>
		</table>	
		}


		{pdfdoc.USER_PDF_DOC_ID>0 && <>
		<table align='center'  style={{width:"55%"}} >
		<tbody>
		<tr>
			<td align="right">Select other pdf file(s) to merge:</td>
			<td align="left"><input type="file" id="fileinput" accept=".pdf,*.jpg,*.png" multiple onChange={(e)=>{handleFileChange(e);}}   />
				{dowait.show==true && <><img src='img/Loading_2.gif' border='0' height='36' /> . . . please wait</>}
				{
				dowait.show==false && axiofl.selectedFiles!=null && 
				<button onClick={(e)=>{insertuserpdfdoc(e);}} className='button' id='btnappendpdf' >upload pdf file</button>
				}
			</td>
		</tr>

		</tbody>
		</table>	
		</>
		}
		
		{tblpdfdoc.length>0 && <>
		<table align='center' className='customers' style={{width:"55%"}} >
		<thead>
		<tr>
			<th>#</th>
			<th>File Name</th>
			<th>Seq #</th>
			<th># of<br/>Pages</th>
			<th>File Size (Kb)</th>
		</tr>
		</thead>
		<tbody>
			{tblpdfdoc}
		</tbody>
		</table>
		
			<p align="center" id="presult" style={{fontWeight:"bold", color:"brown"}} ></p>
			{
			arraypdfdoc.length>=2 && <p align="center" >
				<input id="cbready" type="checkbox" onClick={(e)=>{clickCbready(e);}} /><label htmlFor="cbready" className="hand"  > I am ready to merge the files</label>
				</p>
			}
			{
			cbready.checked==true && 
			<p align="center" id="presult" ><button className="button" onClick={(e)=>{mergepdfdocs(e);}} >merge pdf files</button></p>
			}
		</>
		}
		
		

<div align="center">
<embed id="embed1"
    src=""
	/*"https://customsprem.gov.tc/webuploads/currdoc/Notice%20Of%20Auction%20-%20Providenciales%20Auction%20List%202021.pdf#toolbar=0&navpanes=0&scrollbar=0"*/
    type="application/pdf"
    frameBorder="0"
    scrolling="auto"
    height="800"
    width="95%"
	onLoad={(e)=>{pdfLoaded(e);}}
></embed>
		<p align="center">
		
		Batch Id: <input size="6" defaultValue={pdfdoc.USER_PDF_DOC_ID} readOnly className="gnsbro" style={{textAlign:"center"}} />
		<br/>
		<a href="#" onClick={(e)=>{startover(e);}} >clear form and start over</a>
		</p>

</div>


		
		
		{/*
		file:///D:/aps/000125/Google%20Chrome%20Setting%20for%20Pdf.pdf
		*/}


<div className="modalsm">
    <div className="modalsm-content">
        <span className="close-button"  >&times;</span>
        <div align='center' id='modalsmtext' >
		<p style={{color:"brown",fontWeight:"bold"}} >Add New Worker/ Modify Existing Worker {pdfdoc.USER_PDF_DOC_ID}</p>
		<p style={{color:"brown"}} >Please be certain to spell the name correctly to help find the person</p>
		
		<form id="form1" method="POST"  >
		<table align='center' style={{width:"75%"}} >
		<tbody>
		<tr>
			<td align="right" >Worker's First Name:</td>
			<td align="left" ><input type="text" name="FIRST_NAME" value={pdfdoc.FIRST_NAME} required placeholder='first name' onChange={(e)=>{handleChange(e);}} onFocus={(e)=>{e.target.select();}} autoComplete="off" /></td>
		</tr>

		</tbody>
		</table>
		</form>
	
		</div>
    </div>
</div>
<div id="snackbar">&nbsp;</div>


    </>
  );
  


};


export default Renderpdfdoc;